module.exports = __webpack_public_path__ + "img/bmcl_detail.24a6d083.jpg";